import { EnumDescriptions } from '@/app/shared/utils';
import { i18n } from '@/plugins';

export enum BillingMode {
  OneShot = 1,
  Recurrent = 2,
  Parcel = 3,
  Smart = 4,
  Undefined = 5,
  SmartParcel = 6,
  SmartRecurrent = 7,
  Carnet = 8,
}
EnumDescriptions.setDescriptions(BillingMode, [
  i18n.t('enums.one_shot'),
  i18n.t('enums.recurrent'),
  i18n.t('enums.parcel'),
  i18n.t('enums.smart'),
  i18n.t('enums.undefined'),
  i18n.t('enums.smart_parcel'),
  i18n.t('enums.smart_recurrent'),
  i18n.t('enums.carnet'),
]);
